import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-logout',
  imports: [MatIcon, MatButton, TranslatePipe],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss',
})
export class LogoutComponent {
  public logo = 'icon-app-logo';

  public login() {
    // The scheme must be extracted because of the iOS ionic application having a different scheme than the web application
    const currentScheme = window.location.protocol;
    const currentDomain = window.location.hostname;

    // We need to redirect to the home page of the application using the window location href method
    // This is because the login must happend before the application is loaded and the Angular router must be reinitialized from scratch
    // Otherwise, the application will not promp the user to login again since the platform services
    // are still injected (with existing credentials)
    window.location.href = currentScheme + '//' + currentDomain;
  }
}
